"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumPayableSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const invoice_status_computed_mapping_1 = require("../base/invoice-status-computed-mapping");
const meta_data_invoice_1 = require("../base/meta-data-invoice");
exports.SourgumPayableSchema = {
    name: 'sourgum-payable',
    alias: 'Sourgum Payable',
    shortName: 'Bill',
    applications: ['aap'],
    disabled: false,
    dynamicMapping: false,
    returnType: {
        wayste: transport_types_1.Invoice.PayableTransport,
    },
    searchableAttributes: [
        {
            field: 'invoiceDetails.orderNumber',
            alias: 'Order Number',
            shortName: 'orderNumber',
            searchableByDefault: false,
        },
        {
            field: 'vendorName',
            alias: 'Vendor Name',
            shortName: 'vendor',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.invoiceNumber',
            alias: 'Invoice Number',
            shortName: 'invoiceNumber',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.memo',
            alias: 'Memo',
            shortName: 'memo',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            type: 'STRING',
            field: 'invoiceDetails.status_computed',
            useKeywordSubfield: false,
            alias: 'Bill Status',
            shortName: 'Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Invoice.InvoiceStatusLabels[status],
            })),
        },
        {
            type: 'STRING',
            field: 'invoiceDetails.status',
            alias: 'Bill Status (Legacy - Stale)',
            shortName: 'Status (Legacy)',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Invoice.InvoiceStatusLabels[status],
            })),
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.total',
            alias: 'Total',
            shortName: 'Amount',
            allowedOperators: 'ALL',
            format: 'MONEY',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.refunds.date',
            alias: 'Refund Date',
            shortName: 'Refund Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.payments.paymentSentDate',
            alias: 'Payment Send Date',
            shortName: 'Payment Send Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.payments.paymentReceivedDate',
            alias: 'Payment Received Date',
            shortName: 'Payment Received Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'STRING',
            field: 'invoiceDetails.reviewStatus',
            alias: 'Review Status',
            shortName: 'Review Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Invoice.ReviewStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Invoice.ReviewStatusLabels[status],
            })),
        },
        ...meta_data_invoice_1.MetaDataFiltersInvoice,
    ],
    extraMappings: [invoice_status_computed_mapping_1.InvoiceStatusComputedMapping],
};
//# sourceMappingURL=sourgum-payable.js.map